import React from 'react'
import { LuDollarSign } from 'react-icons/lu'
import NumberConversion from 'Utils/NumberConversion'

const BenefitsView = ({ name, benefit, onCoPaymentClick }) => {
    const familyBenefits = benefit.filter((bene) => bene.benefitLevelCode === "FAM")
    const individualBenefits = benefit.filter((bene) => bene.benefitLevelCode === "IND")
    const remainingBenefits = benefit.filter((bene) => bene.benefitLevelCode !== "IND" && bene.benefitLevelCode !== "FAM")

    const familyInPlan = familyBenefits.filter((bene) => bene.inPlanNetwork === "Y")
    const familyOutPlan = familyBenefits.filter((bene) => bene.inPlanNetwork === "N")
    const familyOthersPlan = familyBenefits.filter((bene) => bene.inPlanNetwork !== "Y" && bene.inPlanNetwork !== "N")

    const individualInPlan = individualBenefits.filter((bene) => bene.inPlanNetwork === "Y")
    const individualOutPlan = individualBenefits.filter((bene) => bene.inPlanNetwork === "N")
    const individualOthersPlan = individualBenefits.filter((bene) => bene.inPlanNetwork !== "Y" && bene.inPlanNetwork !== "N")

    const groupedBenefits = {
        Family: {
            inPlan: familyInPlan,
            outPlan: familyOutPlan,
            others: familyOthersPlan,
        },
        Individual: {
            inPlan: individualInPlan,
            outPlan: individualOutPlan,
            others: individualOthersPlan
        },
    }

    const distinctBenifits = benefit.reduce((a, b) => !a.some(v => v.benefitLevelCode === b.benefitLevelCode) ? [...a, b] : a, [])

    const allBenefits = [...benefit]
    allBenefits.sort((a, b) => {
        const order = distinctBenifits.map(sss => sss.benefitLevelCode);
        return order.indexOf(a.benefitLevelCode) - order.indexOf(b.benefitLevelCode);
    });

    const distinctBenifits2 = allBenefits.reduce((a, b) => !a.some(v => v.inPlanNetwork === b.inPlanNetwork) ? [...a, b] : a, [])

    const allBenefits2 = [...allBenefits]
    allBenefits2.sort((a, b) => {
        const order = distinctBenifits2.map(sss => sss.inPlanNetwork);
        return order.indexOf(a.inPlanNetwork) - order.indexOf(b.inPlanNetwork);
    });

    return (
        <fieldset class="p-4 rounded-xl border border-gray-300">
            <legend class="px-2  ">{name}</legend>
            <div >
                {remainingBenefits.map((r) => {
                    return (
                        <div key={r.id} className={`p-4 mb-4  rounded-md ${r.benefitCoverageCode === "1" ? 'bg-green-200' : r.benefitCoverageDescription === 'Inactive Coverage' ? 'bg-red-300' : 'bg-gray-300'}`}>
                            <h1 className='font-mono capitalize'>{r.benefitNotes}</h1>
                            <h1 className='mb-2 text-xl font-semibold'>{r.planTypeDescription ? `${r.planTypeDescription} - ` : null}{r.benefitCoverageDescription ? `${r.benefitCoverageDescription}` : null} {r.benefitCoverageDescription !== 'Active Coverage' && <>  - {r.benefitAmount ? NumberConversion(r.benefitAmount || 0) : r.benefitPercentage ? `${r.benefitPercentage}%` : NumberConversion(r.benefitAmount)}  {r.benefitPeriodDescription}</>}</h1>
                            <p>{r.entityDescription ? `${r.entityDescription} : ` : null}{r.entityName}</p>
                            <p>{r.entityAddress1 ? `${r.entityAddress1}, ` : null}</p>
                            <p> {r.entityCity ? `${r.entityCity}, ` : null}{r.entityState ? `${r.entityState}, ` : null}{r.entityZip ? `${r.entityZip}, ` : null}</p>
                            <p> {r.entityWebsite ? `Website : ${r.entityWebsite}` : null}</p>
                            <p>{r.entityPhone ? `Phone : ${r.entityPhone}` : null}</p>
                        </div>
                    )
                })}
            </div>
            {Object.entries(groupedBenefits).map((b) => {

                return (
                    <div key={b[0]} className=''>

                        {Object.entries(b[1]).map((c) => {
                            return (
                                <div key={c.id} className={c[1].length > 0 ? c[1][0].benefitLevelDescription ? "p-4 mb-8 bg-gray-100  rounded-md " : "" : null}>
                                    <p className='mb-3 font-semibold'> {c[1].length > 0 ? `${c[1][0].benefitLevelDescription} - ` : null} {c[1].length > 0 ? c[1][0].inPlanNetwork === "Y" ? "In-Plan-Network" : c[1][0].inPlanNetwork === "N" ? "Out-Plan-Network" : "" : null}</p>
                                    {c[1]?.map((b) => {
                                        const label = [b.benefitNotes, b.planTypeDescription, b.benefitCoverageDescription].join(' ').toLowerCase() || '';
                                        const isCoPayment = label.includes('co-payment') || label.includes('copayment');
                                        return (
                                            <div key={b.id} className={`p-4 mb-4 rounded-md ${b.benefitCoverageCode === "1" ? "bg-green-200" : "bg-gray-300"}`}>
                                                <h1 className='font-mono capitalize'>{b.benefitNotes}</h1>
                                                <div className="mb-2 flex items-center gap-3 justify-between">
                                                    <h1 className="text-xl font-semibold ">
                                                        {b.planTypeDescription ? `${b.planTypeDescription} : ` : null}
                                                        {b.benefitCoverageDescription ? `${b.benefitCoverageDescription}` : null}
                                                        {b.benefitCoverageDescription !== 'Active Coverage' && <> : {b.benefitAmount ? NumberConversion(b.benefitAmount || 0) : b.benefitPercentage ? `${b.benefitPercentage}%` : NumberConversion(b.benefitAmount)}  {b.benefitPeriodDescription}</>}
                                                    </h1>
                                                    {isCoPayment && (b.benefitAmount != null && Number(b.benefitAmount) !== 0) && (
                                                            <button
                                                                type="button"
                                                                onClick={() => onCoPaymentClick?.(b)}
                                                                className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200 hover:border-gray-400 transition-colors"
                                                            >
                                                                <LuDollarSign className="w-4 h-4 shrink-0" />
                                                                Add Payment
                                                            </button>
                                                    )}
                                                </div>
                                                <p>{b.entityDescription ? `${b.entityDescription} : ` : null}{b.entityName}</p>
                                                <p>{b.entityAddress1 ? `${b.entityAddress1}, ` : null}</p>
                                                <p> {b.entityCity ? `${b.entityCity}, ` : null}{b.entityState ? `${b.entityState}, ` : null}{b.entityZip ? `${b.entityZip}, ` : null}</p>
                                                <p> {b.entityWebsite ? `Website : ${b.entityWebsite}` : null}</p>
                                                <p>{b.entityPhone ? `Phone : ${b.entityPhone}` : null}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        })}
                    </div>
                )
            })}
        </fieldset>
    )
}

export default BenefitsView